/*
 * Design B, boutique wall. No GSAP: this runs on every template the wall
 * appears on, including collection pages, and it only toggles attributes.
 *
 * 1. Odd walls: marks a wall holding an odd number of pieces, so a phone can
 *    centre the last one (C61).
 * 2. <clinic-floors-nav>: marks the department in view and steps aside once
 *    the visitor is past the last floor.
 *
 * The pieces themselves are static links (C69, C71): the compare seam, its
 * gestures and the lights-up sweep are gone.
 */

// Pieces on one wall are spread over several shelves, so CSS cannot tell
// whether the wall holds an odd number. Mark those walls, so a phone can
// centre the last piece instead of leaving it alone in the left column (C61).
function markOdd() {
  document.querySelectorAll('.clinic-wall').forEach((wall) => {
    wall.toggleAttribute('data-odd', wall.querySelectorAll('.clinic-piece').length % 2 === 1);
  });
}

markOdd();
document.addEventListener('shopify:section:load', markOdd);

if (!customElements.get('clinic-floors-nav')) {
  customElements.define(
    'clinic-floors-nav',
    class extends HTMLElement {
      // Read from layout on scroll rather than IntersectionObserver: an anchor
      // jump or a hard fling can skip a whole floor without ever crossing a
      // threshold, which left the wrong department marked. Scroll events do
      // not bubble, so one capturing listener hears both Horizon scrollers.
      connectedCallback() {
        this.links = [...this.querySelectorAll('a[href^="#"]')];
        this.floors = this.links.map((link) => document.getElementById(link.hash.slice(1))).filter(Boolean);
        if (!this.floors.length) return;

        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.ticking = false;
            this.update();
          });
        };
        // Where the bar sits when stuck, measured without its own transform so
        // stepping aside can never flip the answer back. It only changes with
        // the window size, so it is read here and on resize, never per scroll.
        this.measure = () => {
          this.stuckBottom = (parseFloat(getComputedStyle(this).top) || 0) + this.offsetHeight;
          this.onScroll();
        };
        document.addEventListener('scroll', this.onScroll, { capture: true, passive: true });
        window.addEventListener('resize', this.measure, { passive: true });
        this.stuckBottom = (parseFloat(getComputedStyle(this).top) || 0) + this.offsetHeight;
        this.update();
      }

      update() {
        const line = window.innerHeight * 0.45;
        let current = this.floors[0].id;
        for (const floor of this.floors) {
          if (floor.getBoundingClientRect().top <= line) current = floor.id;
        }
        this.links.forEach((link) => link.toggleAttribute('aria-current', link.hash === `#${current}`));

        const last = this.floors[this.floors.length - 1].getBoundingClientRect();
        this.toggleAttribute('data-past', last.bottom < this.stuckBottom + 40);
      }

      disconnectedCallback() {
        document.removeEventListener('scroll', this.onScroll, { capture: true });
        window.removeEventListener('resize', this.measure);
      }
    }
  );
}
